(function () {
  'use strict';
  var inflight = null, inflightToken = '', privacyReady = null, published = Object.create(null);
  function cookie(name) {
    var match = document.cookie.split('; ').find(function (part) { return part.indexOf(name + '=') === 0; });
    try { return match ? decodeURIComponent(match.slice(name.length + 1)) : ''; } catch (_) { return ''; }
  }
  function receipt() {
    try { return JSON.parse(localStorage.getItem('wynch_club_enrollment_receipt_v1') || 'null'); } catch (_) { return null; }
  }
  window.WynchJoinMetaLeadV1 = function () {
    if (new URL(location.href).searchParams.get('wynch_qa') === '1') return Promise.resolve();
    var r = receipt();
    if (!r || r.source !== 'join' || !r.continuationToken) return Promise.resolve();
    if (inflight) return inflightToken === r.continuationToken ? inflight : inflight.then(function () { return window.WynchJoinMetaLeadV1(); });
    var token = r.continuationToken;
    inflightToken = token;
    inflight = (async function () {
      // Standalone Join has no main-header privacy initializer. Load the native
      // read API explicitly; never treat an absent API as permission to track.
      if (!window.Shopify) return;
      if (!window.Shopify.customerPrivacy && typeof window.Shopify.loadFeatures === 'function') {
        await (privacyReady || (privacyReady = new Promise(function (resolve) {
          window.Shopify.loadFeatures([{name:'consent-tracking-api',version:'0.2'}],function (error) { resolve(!error); });
        })));
      }
      var p = window.Shopify.customerPrivacy;
      if (!p) { console.info('WYNCH Join Meta: customer privacy API unavailable'); return; }
      if (!p.marketingAllowed() || !p.analyticsProcessingAllowed() || !p.saleOfDataAllowed()) { console.info('WYNCH Join Meta: tracking consent not allowed'); return; }
      var result;
      for (var attempt = 0; attempt < 2; attempt++) {
        try {
          var response = await fetch('/apps/wynch-email/join-meta-lead', {method:'POST',headers:{'content-type':'application/json'},body:JSON.stringify({contract_version:'1.0.0',continuation_token:token,marketing_allowed:true,sale_allowed:true,fbp:cookie('_fbp'),fbc:cookie('_fbc')}),keepalive:true});
          if (!response.ok) throw Error('JOIN_META_REQUEST_FAILED');
          result = await response.json(); break;
        } catch (error) { if (attempt) throw error; await new Promise(function(resolve){setTimeout(resolve,1500);}); }
      }
      var current = receipt();
      if (!current || current.continuationToken !== token || !result || result.duplicate === true || !['accepted','queued'].includes(result.status) || !/^join-lead-[a-f0-9]{64}$/.test(result.event_id) || published[result.event_id]) return;
      if (window.Shopify.analytics && typeof window.Shopify.analytics.publish === 'function') {
        await window.Shopify.analytics.publish('wynch:newsletter_signup',{source:'join',state:'awaiting_doi_confirmation',event_id:result.event_id});
        published[result.event_id] = true;
      }
    })().catch(function () { console.warn('WYNCH Join: Meta delivery could not be verified'); }).finally(function () { inflight = null; });
    return inflight;
  };
  document.addEventListener('visitorConsentCollected', function () {
    var r = receipt();
    if (r && r.source === 'join') window.WynchJoinMetaLeadV1();
  });
  // Recover an accepted pending request after a reload or delayed consent API.
  // The server receipt decides eligibility and suppresses already sent events.
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function () { window.WynchJoinMetaLeadV1(); }, {once:true});
  else window.WynchJoinMetaLeadV1();
})();
